import { SectionOfDashboard } from "./SectionOfDashboard";

export class DashboardTemplateResponse {
  templateId?: string;
  dateCreated!: string;
  name!: string;
  sections!: SectionOfDashboard[];
}
